import { createCustomTheme } from '@domains/subscription/theme'
import { ThemeProvider } from '@mui/material'
import { useCustomerInvoice } from '../api/queries'
import { InvoiceSummary } from '../usecases/InvoiceSummary'

interface InvoiceSummaryFactory {
  customerId: string
}

export const InvoiceSummaryFactory = ({ customerId }: InvoiceSummaryFactory) => {
  const { data: invoice, isLoading, isFetching, isError } = useCustomerInvoice(customerId)

  return (
    <ThemeProvider theme={createCustomTheme()}>
      <InvoiceSummary invoice={invoice} isLoading={isLoading || isFetching} isError={isError} />
    </ThemeProvider>
  )
}
